<template>
  <div
    :class="['form__group', {'camp__size--xs': field.size === 'xs'}]"
  >
    <ValidationProvider
      :name="field.id"
      :rules="rules"
      v-slot="{ errors }"
    >
      <Component
        :is="componentRenderType"
        v-model="model[field.model]"
        :readonly="field.readonly"
        :id="field.id"
        :disabled="field.disabled"
        :options="field.options"
        :label="fieldHasLabel ? field.label : null"
        v-mask="maskType"
        size='sm'
        :error-warning="errors.length > 0"
        @input="$emit('input', $event)"
        @click="$emit('click', $event)"
        @focus="$emit('focus')"
      />

      <div
        class="form__alert form__alert--error"
        v-show="errors.length"
      >
        <span class="di di-icon-alert-circle"></span> {{ errors[0] }}
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import capitalizeText from '@/utils/helpers/filters/capitalizeText';
import { maskTypes } from '@/utils/helpers/maskers/maskTypes';

export default {
  name: 'FormGroup',
  data: () => ({
  }),
  props: {
    field: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    rules: {
      type: String,
      default: ''
    }
  },
  computed: {
    fieldHasLabel() {
      return !!this.field.label;
    },
    maskType() {
      const fieldDataType = this.field.model;
      const fieldModelValue = this.model[this.field.model];

      if (fieldDataType === 'phone') {
        return fieldModelValue.match(/( 9)/) ? maskTypes.cellphone : maskTypes[fieldDataType];
      }

      return maskTypes[fieldDataType];
    },
    // Get type of field 'V + xxx'. It'll be the name of the component
    componentRenderType() {
      return 'V' + capitalizeText(this.field.type);
    },
  },
};
</script>

<style lang="scss" scoped>

.form {
  &__group {
    display: flex;
    flex-direction: column;
    margin: 8px  0 12px 0;
    width: 100%;

  }

  .camp__size--xs {
    width: 49%;
  }

  .camp__size--xs ~ .camp__size--xs {
    margin-left: 2%;
  }

  &__label {
    align-self: start;
    font-size: var(--font-size-1);
    color: var(--color-grey-7);
    margin-bottom: 0.3rem;
  }

  &__alert {
    margin-top: 5px;
    text-align: left;

    &--error {
      color: var(--color-error);
      font-size: var(--font-size-1);
    }

    span {
      margin-right: 3px;
    }
  }
}
</style>
